import { render } from "./LabelListView.vue?vue&type=template&id=566c8349&scoped=true"
import script from "./LabelListView.vue?vue&type=script&lang=js"
export * from "./LabelListView.vue?vue&type=script&lang=js"

import "./LabelListView.vue?vue&type=style&index=0&id=566c8349&lang=scss&scoped=true"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566c8349"]])

export default __exports__